import { render, staticRenderFns } from "./ViewBag.vue?vue&type=template&id=526bcd72&scoped=true&"
import script from "./ViewBag.vue?vue&type=script&lang=js&"
export * from "./ViewBag.vue?vue&type=script&lang=js&"
import style0 from "./ViewBag.vue?vue&type=style&index=0&id=526bcd72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bcd72",
  null
  
)

export default component.exports